import React, { useState, useMemo } from 'react';
import { theme } from '../../theme';
import { useMatchGroup } from '../../hooks/useMatchGroup';
import { MatchGroupPickerModal } from './MatchGroupPickerModal';

interface Props {
  matchId: string;
  currentGroupName?: string | null;
}

export function GroupAssociationSection({ matchId, currentGroupName }: Props) {
  const { eligibleGroups, currentGroupId, setGroup, loading } = useMatchGroup(matchId);
  const [modalOpen, setModalOpen] = useState(false);

  const displayName = useMemo(() => {
    if (!currentGroupId) return null;
    const fromList = eligibleGroups.find(g => g.id === currentGroupId);
    return fromList?.name ?? currentGroupName ?? null;
  }, [currentGroupId, eligibleGroups, currentGroupName]);

  if (loading) return null;

  const hasEligible = eligibleGroups.length > 0;
  const associated = currentGroupId !== null;

  if (!associated && !hasEligible) return null;

  const label = associated ? `Grupo: ${displayName || ''}` : 'Sin grupo asignado';
  const buttonLabel = associated ? 'Editar' : 'Asociar';

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing.sm,
          padding: `${theme.spacing.sm} ${theme.spacing.md}`,
          margin: `${theme.spacing.sm} 0`,
          backgroundColor: theme.colors.surface,
          borderRadius: theme.borderRadius.input,
          border: `1px solid ${theme.colors.border}`,
        }}
      >
        <span style={{ fontSize: '18px' }} aria-hidden>👥</span>
        <span
          style={{
            flex: 1,
            color: theme.colors.text,
            fontFamily: theme.fonts.body,
            fontSize: theme.fonts.sizeBody,
          }}
        >
          {label}
        </span>
        {hasEligible && (
          <button
            onClick={() => setModalOpen(true)}
            style={{
              padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
              backgroundColor: 'transparent',
              color: theme.colors.primary,
              border: `1px solid ${theme.colors.primary}`,
              borderRadius: theme.borderRadius.button,
              fontSize: theme.fonts.sizeSmall,
              fontFamily: theme.fonts.body,
              fontWeight: theme.fonts.weightBold,
              cursor: 'pointer',
            }}
          >
            {buttonLabel}
          </button>
        )}
      </div>
      <MatchGroupPickerModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        groups={eligibleGroups}
        currentGroupId={currentGroupId}
        onSave={setGroup}
      />
    </>
  );
}
